var POPPER_REFERENCE_HIDDEN_ATTRIBUTE = 'data-popper-reference-hidden';
/**
 * Defines a Popper modifier that will close a Popper-controlled layer
 * component by setting `pvdOpen` to `false`. Modifier can be disabled by
 * setting `pvdDisableOverflow` to `true`.
 *
 * @param componentName - the name of layer component that will be used to name the CustomEvent
 *
 * @emits
 * pvd-{{componentName}}-reference-hidden
 */
function getCloseIfTriggerHiddenPopperModifier(componentName) {
    var _this = this;
    return {
        name: 'closeIfTriggerHidden',
        enabled: !this.pvdDisableOverflow,
        phase: 'beforeWrite',
        requires: ['hide'],
        fn: function (_a) {
            var state = _a.state;
            if (_this.pvdDisableOverflow) {
                return;
            }
            var isTriggerHidden = state.attributes.popper && state.attributes.popper[POPPER_REFERENCE_HIDDEN_ATTRIBUTE];
            if (_this.pvdOpen && isTriggerHidden) {
                _this.dispatchEvent(new CustomEvent("pvd-".concat(componentName, "-reference-hidden")));
                _this.pvdOpen = false;
            }
        },
    };
}

export { getCloseIfTriggerHiddenPopperModifier };
